import axios from "axios";
import { EventosModel, SelectModel } from "../../pages/eventos/models/EventosModel";
const API_URL = process.env.REACT_APP_API;

export async function obtenerEventos() {
  try {
    const response = await axios.get(`${API_URL}eventos`);
    const data = response.data.doc.data;
    return data;
  } catch (error) {
    console.log(error);
    throw error;
  }
}
export async function obtenerEventosSelect() {
  try {
    const response = await axios.get(`${API_URL}eventos`);
    const data = response.data?.doc?.data?.rows || [];
    const eventos = data.filter((evento: { status: { code: string } }) => evento.status.code !== "PEND");
    const select: SelectModel[] = eventos.map((item: any) => ({
      id: Number(item.id),
      value: item.id,
      label: `${item.nombre} ${item.status.code === 'ACTIVE' ? '(Activo)' : ''}`,
      data: item,
      actual: item.actual
    }));
    return select;
  } catch (error) {
    console.error("Error en obtenerEventosSelect:", error);
    throw error;
  }
}

export async function obtenerEventosConTicketsSelect() {
  try {
    const response = await axios.get(`${API_URL}eventos/con-tickets`);
    const data = response.data?.doc?.data?.rows || [];
    const select: SelectModel[] = data.map((item: any) => ({
      id: Number(item.id),
      value: item.id,
      label: `${item.nombre} ${item.status?.code === 'ACTIVE' ? '(Activo)' : ''}`,
      data: item,
      actual: item.actual
    }));
    return select;
  } catch (error) {
    console.error("Error en obtenerEventosConTicketsSelect:", error);
    throw error;
  }
}

export async function crearEventoService(evento: EventosModel) {
  try {
    const { id, nombre, fecha_inicio, fecha_fin, imagen, descripcion, ubicacion, recinto_id, mapa_ubicaciones, organizador_nombre, organizador_imagen, mostrar_menus, mostrar_recargas, visible_app } = evento;
    const url = `${API_URL}eventos${id ? `/${id}` : ''}`;

    const payload = { nombre, fecha_inicio, fecha_fin, imagen, descripcion, ubicacion, recinto_id: recinto_id || null, mapa_ubicaciones: mapa_ubicaciones || null, organizador_nombre, organizador_imagen, mostrar_menus: mostrar_menus || false, mostrar_recargas: mostrar_recargas || false, visible_app: visible_app !== undefined ? visible_app : true };

    const response = id
      ? await axios.patch(url, payload)
      : await axios.post(url, payload);

    return response;
  } catch (error) {
    console.error('Error en crearEventoService:', error);
    throw error;
  }
}

export async function uploadImagenEvento(file: File) {
  try {
    const formData = new FormData();
    formData.append('imagen', file);

    // Configurar headers para multipart/form-data
    const response = await axios.post(`${API_URL}eventos/upload/image`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    });

    // Retornamos directamente la data que contiene el payload { imageUrl: ... }
    return response.data;
  } catch (error) {
    console.error('Error al subir la imagen:', error);
    throw error;
  }
}

export async function estatusEventoService(id: number, status_id: number) {
  try {
    const url = `${API_URL}eventos/${id}`;
    const response = await axios.patch(url, { status_id });
    return response;
  } catch (error) {
    console.error('Error en cambiar el estatus del evento:', error);
    throw error;
  }
}

/** Devuelve los eventos con status ACTIVE disponibles para el selector post-login. */
export async function getEventosActivosService() {
  try {
    const response = await axios.get(`${API_URL}eventos-activos`);
    return (response.data?.data ?? []) as Array<{
      id: number;
      nombre: string;
      fecha_inicio: string;
      fecha_fin: string;
      imagen: string | null;
    }>;
  } catch (error) {
    console.error('Error en getEventosActivosService:', error);
    throw error;
  }
}

/** Segundo paso del login: envía evento_id y recibe un nuevo JWT con ese contexto. */
export async function selectEventoService(evento_id: number) {
  try {
    const response = await axios.post(`${API_URL}select-evento`, { evento_id });
    return response.data as { accessToken: string; expiresIn: string };
  } catch (error) {
    console.error('Error en selectEventoService:', error);
    throw error;
  }
}
export async function obtenerEventoPorIDService(id: number) {
  try {
    const response = await axios.get(`${API_URL}/eventos/${id}`);
    let evento = response.data.doc.data;
    evento = {
      ...evento,
      fecha_inicio: new Date(evento.fecha_inicio).toISOString().split('T')[0],
      fecha_fin: new Date(evento.fecha_fin).toISOString().split('T')[0],
    };
    return evento;
  } catch (error) {
    console.log("ERROR: ", error);
    throw error;
  }
}


